<template>
  <div
    data-testid="stage-scaler"
    :class="[
      $style.root,
      {
        [$style.cellphone]: $store.state.branding.currentView === 'cellphone'
      }
    ]"
    :style="$store.getters['branding/themeStyles']"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'StageScaler'
};
</script>

<style module lang="scss">
.root {
  width: calc(0.5 * 100vw);
  height: calc(0.5 * 100vh);
  margin-bottom: 24px;

  &.cellphone {
    width: calc(0.85 * 348px);
    height: calc(0.85 * 620px);
  }
}
</style>
